import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Settings from './components/Settings';
import { AssetContextProvider } from './contexts/AssetContext';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');

  return (
    <AssetContextProvider>
      <div className="min-h-screen bg-gray-50">
        <Header setCurrentView={setCurrentView} currentView={currentView} />
        <main className="container mx-auto px-4 py-8">
          {currentView === 'dashboard' && <Dashboard />}
          {currentView === 'settings' && <Settings />}
        </main>
      </div>
    </AssetContextProvider>
  );
}

export default App;
